import React from "react";
import maa from '../assets/TahiraFaheem.jpg';
// import video from '../assets/nazanin.mp4'; // Import the video file
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">Maths Tutor at FutureMedsAcademy</p>
          <p className="text-blk subHeading">
          Tahira Faheem – Cambridge-Certified Mathematics Specialist

Tahira Faheem is a highly experienced Mathematics educator with 13 years of teaching expertise at renowned institutions like The City School and Beaconhouse. She is Cambridge-certified for both O-Level Mathematics and Additional Mathematics and has also taught O-Level Physics.

With a strong commitment to professional development, she has conducted multiple training sessions for teachers, focusing on effective teaching strategies. She has also completed subject specialist training from Cambridge and holds a Master’s degree in Mathematics.

Passionate about fostering analytical thinking, Tahira equips her students with problem-solving skills and critical reasoning, preparing them for success in Cambridge examinations.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>

        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImg"
            src={maa}
            alt="Main"
          />
          <h1>Tahira Faheem</h1>
          {/* <video
            className="mainVideo"
            controls
            autoPlay
            loop
            muted
            src={video}
            alt="Video"
          /> */}

       
        </div>
     
      </div>
    </div>
  );
};

export default AboutUs;